/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   10/11/21
 */

import {createClient, dedupExchange, fetchExchange, subscriptionExchange} from "urql";
import { SubscriptionClient } from 'subscriptions-transport-ws';
import { devtoolsExchange } from "@urql/devtools";
import {UserState} from "../state/reducers/user";
import {Dispatch} from "redux";
import getCacheExchange from "./urql/cache-exchange";
import getErrorExchange from "./urql/error-exchange";
import getAuthExchange from "./urql/auth-exchange";
import {getDataUrl} from "./environment";

export interface UrqlClientOptions {
	user: UserState
	dispatch: Dispatch<any>
}

const subscriptionClient = new SubscriptionClient(
	getDataUrl("ws") + "/graphql",
	{
		reconnect: true
	}
);


export default function getClient(options: UrqlClientOptions) {

	return createClient({
		url: getDataUrl() + "/graphql",
		exchanges: [
			devtoolsExchange,
			dedupExchange,
			getCacheExchange(),
			getErrorExchange(),
			getAuthExchange(options.user),
			fetchExchange,
			subscriptionExchange({// @ts-ignore
				forwardSubscription: (operation) => subscriptionClient.request(operation)
			})
		],
		fetchOptions: () => {
			return {
				credentials: "include",
				headers: {
					"apollographql-client-name": "web",
					"apollographql-client-version": process.env.REACT_APP_VERSION as string
				},
			};
		},
	});
};

